function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { transition } from 'd3-transition';
import { select } from 'd3-selection';
import { arc } from 'd3-shape';
import { interpolate } from 'd3-interpolate';
import cx from 'classnames';
var d3 = {
  select: select,
  transition: transition,
  arc: arc,
  interpolate: interpolate
};

var Arc = /*#__PURE__*/function (_PureComponent) {
  _inherits(Arc, _PureComponent);

  var _super = _createSuper(Arc);

  function Arc() {
    var _this;

    _classCallCheck(this, Arc);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "arcOutput", d3.arc() // eslint-disable-next-line react/destructuring-assignment
    .innerRadius(100 - _this.props.outerRadius).outerRadius(100).cornerRadius(0));

    _defineProperty(_assertThisInitialized(_this), "arcTween", function (oldData, newData, arcFn) {
      var copy = _objectSpread({}, oldData);

      return function () {
        var interpolateStartAngle = d3.interpolate(oldData.startAngle, newData.startAngle);
        var interpolateEndAngle = d3.interpolate(oldData.endAngle, newData.endAngle);
        return function (t) {
          copy.startAngle = interpolateStartAngle(t);
          copy.endAngle = interpolateEndAngle(t);
          return arcFn(copy);
        };
      };
    });

    _defineProperty(_assertThisInitialized(_this), "computeStyle", function (colorClass) {
      var color = _this.props.color;

      if (_typeof(color) === 'object' || color.startsWith('#')) {
        return {
          style: {
            fill: color
          }
        };
      } else {
        return {
          className: colorClass
        };
      }
    });

    return _this;
  }

  _createClass(Arc, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var d = this.props.d;
      d3.select(this.node).transition().duration(300).attr('d', this.arcOutput(d)).attrTween('d', this.arcTween(prevProps.d, d, this.arcOutput));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          color = _this$props.color,
          d = _this$props.d,
          onFocus = _this$props.onFocus,
          onBlur = _this$props.onBlur,
          onClick = _this$props.onClick,
          onKeyDown = _this$props.onKeyDown;
      var className = cx(_defineProperty({}, "fill--".concat(color), typeof color !== 'undefined'));
      return /*#__PURE__*/React.createElement("path", _extends({
        d: this.arcOutput(d)
      }, this.computeStyle(className), {
        onMouseOver: onFocus,
        onMouseOut: onBlur,
        onFocus: onFocus,
        onBlur: onBlur,
        onClick: onClick,
        onKeyDown: onKeyDown,
        ref: function ref(node) {
          _this2.node = node;
        }
      }));
    }
  }]);

  return Arc;
}(PureComponent);

_defineProperty(Arc, "propTypes", {
  color: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  d: PropTypes.object,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  onClick: PropTypes.func,
  onKeyDown: PropTypes.func,
  outerRadius: PropTypes.number
});

export { Arc as default };
Arc.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "arcTween",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "oldData",
      "type": null
    }, {
      "name": "newData",
      "type": null
    }, {
      "name": "arcFn",
      "type": null
    }],
    "returns": null
  }, {
    "name": "computeStyle",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "colorClass",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "Arc",
  "props": {
    "color": {
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "object"
        }]
      },
      "required": false,
      "description": ""
    },
    "d": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    },
    "onBlur": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onFocus": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onKeyDown": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "outerRadius": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    }
  }
};